// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__84QU2","modalForm":"UpgradeEpcsModal_modalForm__3LwG1","modalFooter":"UpgradeEpcsModal_modalFooter__3SGIm"};